@if (cart.deliveryCostPending?.value > 0) {
  @if (cart.orderValueMissing?.value === 0) {
    <span>
      {{ 'orderCost.noticeNoShippingCost' | cxTranslate }}
    </span>
  } @else {
    <span>
      {{ 'orderCost.noticeOrderValueMissingForNoShippingCost' | cxTranslate: {
      orderValuePriceMissing: cart.orderValueMissing?.formattedValue } }}
    </span>
  }
}